import styles from './Observations.module.css';

import SamplePhoto from './../../../../assets/images/Photo.png';
import RecordsCard from '../../../../components/RecordsCard/RecordsCard';
import SearchBar from '../../../../components/SearchBar/SearchBar';
import IconAndName from '../../../../components/IconAndName/IconAndName';
import { IoAddCircleOutline } from 'react-icons/io5';
import { openModal } from '../../../../redux/slices/modalSlice';
import { useDispatch } from 'react-redux';

function Observations() {
  const dispatch = useDispatch();
  const mockData = [
    {
      type: 'Observation',
      description: 'Some text',
      students: ['Student 1', 'Student 2'],
      staff: ['Staff A', 'Staff B'],
      lessons: ['English', 'Maths'],
      footerNote: 'Final comment goes here',
      time: '1:30 PM',
      createdAt: '5th July 2025',
      likes: 2,
      views: 10,
      comments: 1,
      labels: {
        students: 'Learners',
        staff: 'Mentors',
        lessons: 'Topics Covered',
      },
      image: SamplePhoto,
    },
    {
      type: 'Observation',
      description:
        'Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.',
      students: ['Student 1', 'Student 1', 'Student 1'],
      staff: ['Student 1', 'Student 1', 'Student 1'],
      lessons: ['Maths', 'Science'],
      footerNote:
        'Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.',
      createdAt: '3rd June 2025',
      time: '12:00 PM',
      likes: 0,
      views: 0,
      comments: 1,
      image: SamplePhoto,
    },
    {
      type: 'Observation',
      description:
        'Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.',
      students: ['Student 1', 'Student 1', 'Student 1'],
      staff: ['Student 1', 'Student 1', 'Student 1'],
      lessons: ['Maths', 'Science'],
      footerNote:
        'Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.',
      createdAt: '3rd June 2025',
      time: '12:00 PM',
      likes: 0,
      views: 0,
      comments: 1,
      image: SamplePhoto,
    },
  ];
  return (
    <div className={styles.Observations}>
      <header className={styles.topBar}>
        <SearchBar placeholder="Search by student name" />
        <IconAndName
          icon={<IoAddCircleOutline />}
          title="Add Observation"
          bgColor="Primary_Color"
          onClick={() => dispatch(openModal('addObservation'))}
        />
      </header>
      <div className={styles.cardGrid}>
        {mockData.map((record, index) => (
          <RecordsCard key={index} data={record} />
        ))}
      </div>
    </div>
  );
}

export default Observations;
